import { Box } from "@mui/material";
import { useParams } from "react-router";
import { CardDetails } from "./CardDetails";
import { ManageTransactions } from "./ManageTransactions";
import { useDispatch } from "react-redux";
import { SET_SELECTED_HISTORY_CARD } from "../../redux/reducers/cardReducer";

export function HistoryCard() {
  const dispatch = useDispatch();

  const urlId = useParams<{ id: string }>();
  const historyCard = urlId.id;

  dispatch({ type: SET_SELECTED_HISTORY_CARD, historyCard });

  return (
    <>
      <Box>
        <Box className="CardInfo">
          <CardDetails cardSystemId={urlId.id} />
          <Box>
            <ManageTransactions />
          </Box>
        </Box>
      </Box>
    </>
  );
}
